import React from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import FileTextIcon from '../Icons/FileText';
import ButtonLink from '../ButtonLink';
import CollapsibleItem from '../CollapsibleItem';

const Component = () => {
  return (
    <Styles>
      <h2 className='type-h4'>Instant Access</h2>
      <p className='type-caption'>
        Documents require free{' '}
        <a
          href='https://get2.adobe.com/reader/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Adobe Reader
        </a>
      </p>
      <ul className='links'>
        <li className='link'>
          <CollapsibleItem
            title={
              <div className='title'>
                <FileTextIcon /> <span> Auto Draft Letter </span>
              </div>
            }
          >
            <a
              href='/resources/documents-forms/Auto-Draft-Letter.pdf'
              target='_blank'
              rel='noreferrer noopener'
            >
              All Other States
            </a>
            <a
              href='/resources/documents-forms/Auto-Draft-Letter-(NC_Only).pdf'
              target='_blank'
              rel='noreferrer noopener'
            >
              North Carolina
            </a>
          </CollapsibleItem>
        </li>
        <li className='link'>
          <a
            href='/resources/documents-forms/Lien-Release-Letter.pdf'
            target='_blank'
            rel='noreferrer noopener'
          >
            <FileTextIcon /> Request Lien Release
          </a>
        </li>
        <li className='link'>
          <CollapsibleItem
            title={
              <div className='title'>
                <FileTextIcon />
                <span> Request Name Change </span>
              </div>
            }
          >
            <a
              className='padding-bottom'
              href='/resources/documents-forms/Name-Change-Request.pdf'
              target='_blank'
              rel='noreferrer noopener'
            >
              All Other States
            </a>
            <a
              className='padding'
              href='/resources/documents-forms/Name-Change-Request_(NC).pdf'
              target='_blank'
              rel='noreferrer noopener'
            >
              North Carolina
            </a>
          </CollapsibleItem>
        </li>
        <li className='link'>
          <a
            href='/resources/documents-forms/LOA-Form.pdf'
            target='_blank'
            rel='noreferrer noopener'
          >
            <FileTextIcon /> Letter of Authorization
          </a>
        </li>
      </ul>
    </Styles>
  );
};

Component.propTypes = {};

export default Component;
